import { Box, Stack } from "@chakra-ui/react";
import { getCdnImageSrc, Image, VStack, responsive, colors } from "goi_common";

export default function FlowerBenefitSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.black}>
      <VStack
        maxWidth={`${1200}px`}
        gap="28px"
        css={responsive({
          padding: {
            base: "64px 24px",
            lg: "120px 24px",
          },
        })}
      >
        <VStack
          width="100%"
          css={responsive({
            alignItems: { base: "center", lg: "flex-start" },
            marginBottom: "40px",
          })}
          gap="16px"
        >
          <Box
            className="white head_28_b lg_head_42_b"
            css={responsive({ textAlign: { base: "center", lg: "left" } })}
          >
            원하는 모든 종류의 <br className="lg_over_hidden" /> 화환/화분
            발송이 가능합니다.
          </Box>
          <Box
            className="gray300 subtitle_16_m lg_head_24_r"
            css={responsive({ textAlign: { base: "center", lg: "left" } })}
          >
            더 이상 개별 꽃집에 하나씩 연락하지 마세요
            <br />
            전국 유통망을 통해 발주/증빙 관리가 가능합니다.
          </Box>
        </VStack>

        <Stack
          css={responsive({
            flexDirection: { base: "column", lg: "row" },
            alignItems: { base: "center", lg: "flex-end" },
          })}
          gap="10px"
        >
          <BenefitItem num={1} title={"근조화환"} />
          <BenefitItem num={2} title={"근조기"} />
          <BenefitItem num={3} title={"축화화환"} />
          <BenefitItem num={4} title={"축화화분"} />
        </Stack>
      </VStack>
    </VStack>
  );
}

function BenefitItem({ num, title }: { num: number; title: string }) {
  return (
    <VStack
      css={{
        background: colors.warmGray150,
        padding: "20px",
        borderRadius: "10px",
      }}
      alignItems="center"
      gap="16px"
    >
      <Box className="orange650 head_24_b">0{num}</Box>
      <Box className="gray900 head_24_b">{title}</Box>
      <Box css={responsive({ width: { base: "260px", lg: "200px" } })}>
        <Image
          src={getCdnImageSrc(`b2b/flower/flower-type-1-${num}.png`)}
          width="100%"
          height="auto"
          alt=""
        />
      </Box>
    </VStack>
  );
}
